export default function (settings) {
  return {
    type: 'SAVE_SETTINGS',
    settings,
  }
}